import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { styled } from 'styled-components'

import { Link } from '@b-stock/fe-core/bstock-react'
import { Colors, Typography } from '@b-stock/fe-core/design-system'

/**
 * To override these default styles, e.g.:
 *   const Description = styled(MarkdownRenderer)``
 */
const Body = styled.div`
  ${Typography.Body2}
  color: ${Colors.Semantic.Neutral.black};

  ul,
  ol {
    margin: 1rem 0;
    padding-left: 1.5rem;
  }

  ul li {
    list-style-type: disc;
  }

  ol li {
    list-style-type: decimal;
  }

  li {
    margin: 0.25rem 0;
  }

  table {
    border-collapse: collapse;
    width: 100%;
  }

  th {
    ${Typography.Overline2}
    background-color: ${Colors.Semantic.Neutral.light_grey};
    border-bottom: 0.03125rem solid ${Colors.Semantic.Neutral.medium_grey};
    border-top: 0.03125rem solid ${Colors.Semantic.Neutral.medium_grey};
    padding: 1rem;
    text-align: left;
    text-transform: uppercase;
  }

  td {
    ${Typography.Body3}
    background-color: ${Colors.Semantic.Neutral.white};
    border-bottom: 0.03125rem solid ${Colors.Semantic.Neutral.medium_grey};
    border-top: 0.03125rem solid ${Colors.Semantic.Neutral.medium_grey};
    padding: 1rem;
    transition: background-color 0.25s ease-in-out;
  }

  tr:hover td {
    background-color: ${Colors.Semantic.BStock.background.lightBackground};
  }
`

export const MarkdownRenderer = ({
  children,
  className,
  linkClickedHandler,
}: {
  children: string
  className?: string
  linkClickedHandler?: (href: string) => void
}) => (
  <Body className={className}>
    <ReactMarkdown
      components={{
        a: ({ href, children }) => (
          // Sandbox potentially unsafe user-generated links
          <Link
            href={href || '#'}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => linkClickedHandler?.(href ?? '')}
          >
            {children}
          </Link>
        ),
      }}
      disallowedElements={['img']}
      remarkPlugins={[remarkGfm]}
    >
      {children}
    </ReactMarkdown>
  </Body>
)
